<div class="text-center">
  <p class="font_size_16" [innerHTML]="data.confirmation_text"></p>
  <div class="flex_center gap_top_4">
    <button
      tabindex="-1"
      (click)="closeDialog('no')"
      class="btn btn_grey_transparent btn-md"
    >
      No
    </button>
    <button
      #delete
      (click)="closeDialog('yes')"
      class="ms-3 btn btn_primary btn-md"
    >
      Yes
    </button>
  </div>
</div>
